<template>
  <div class="table-th">
    <template v-if="header.id === 'checkbox'">
      <vchecklabel v-model="selectedAll" />
    </template>

    <template v-else-if="header.id === 'avatar'">
      <div class="column-filter">
        <div class="cell-flex pointer" @click="setSortingMethod('name')">
          {{ $tr('common.list.candidate') }}

          <div
            class="table-row-icon_wrapper table-row-icon_wrapper__sort"
            :class="{
              active: sorting.name === 'name',
              'sorting-down': sorting.order === 'desc',
              'sorting-up': sorting.order === 'asc'
            }"
          >
            <svg class="table-row-icon">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
            <svg class="table-row-icon table-row-icon-reverse">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'vacancy'">
      <div class="column-filter">
        <div class="cell-flex pointer" @click="setSortingMethod('vacancy')">
          {{ $tr('common.list.vacancy') }}

          <div
            class="table-row-icon_wrapper table-row-icon_wrapper__sort"
            :class="{
              active: sorting.name === 'vacancy',
              'sorting-down': sorting.order === 'desc',
              'sorting-up': sorting.order === 'asc'
            }"
          >
            <svg class="table-row-icon">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
            <svg class="table-row-icon table-row-icon-reverse">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'status'">
      <div class="column-filter">
        <div class="cell-flex pointer" @click="setSortingMethod('status')">
          {{ $tr('common.list.status') }}

          <div
            class="table-row-icon_wrapper table-row-icon_wrapper__sort"
            :class="{
              active: sorting.name === 'status',
              'sorting-down': sorting.order === 'desc',
              'sorting-up': sorting.order === 'asc'
            }"
          >
            <svg class="table-row-icon">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
            <svg class="table-row-icon table-row-icon-reverse">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'rating'">
      <div class="column-filter">
        <div class="cell-flex pointer" @click="setSortingMethod('rating')">
          {{ $tr('common.list.rating') }}

          <div
            class="table-row-icon_wrapper table-row-icon_wrapper__sort"
            :class="{
              active: sorting.name === 'rating',
              'sorting-down': sorting.order === 'desc',
              'sorting-up': sorting.order === 'asc'
            }"
          >
            <svg class="table-row-icon">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
            <svg class="table-row-icon table-row-icon-reverse">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="header.id === 'date'">
      <div class="column-filter" style="z-index: 10000">
        <div class="cell-flex pointer">
          <div class="column-filter">
            <span @click="setSortingMethod('date')">{{ $tr('common.list.created') }}</span>

            <div class="column-filter-icon" @click.stop="set_show_filter('date')">
              <icon-filter :color="filter.date.length > 0 ? 'green' : 'grey'" />
            </div>

            <vtfilter
              v-if="show_filter === 'date'"
              class="th_filter"
              type="date"
              :dates="filter_temp_dates_created"
              @input="set_filter_temp_dates_created"
              @apply="apply_filter('date')"
              @cancel="cancel_filter"
              @clear="date_clear('date')"
            />
          </div>

          <div
            class="table-row-icon_wrapper table-row-icon_wrapper__sort"
            :class="{
              active: sorting.name === 'date',
              'sorting-down': sorting.order === 'desc',
              'sorting-up': sorting.order === 'asc'
            }"
            @click="setSortingMethod('date')"
          >
            <svg class="table-row-icon">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
            <svg class="table-row-icon table-row-icon-reverse">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="header.id === 'date_sent'">
      <div class="column-filter" style="z-index: 10000">
        <div class="cell-flex pointer">
          <div class="column-filter">
            <span @click="setSortingMethod('date_sent')">{{ $tr('common.list.date') }}</span>

            <div class="column-filter-icon" @click.stop="set_show_filter('date_sent')">
              <icon-filter :color="filter.date_sent.length > 0 ? 'green' : 'grey'" />
            </div>

            <vtfilter
              v-if="show_filter === 'date_sent'"
              class="th_filter"
              type="date"
              :dates="filter_temp_dates"
              @input="set_filter_temp_dates"
              @apply="apply_filter('date_sent')"
              @cancel="cancel_filter"
              @clear="date_clear('date_sent')"
            />
          </div>

          <div
            class="table-row-icon_wrapper table-row-icon_wrapper__sort"
            :class="{
              active: sorting.name === 'date_sent',
              'sorting-down': sorting.order === 'desc',
              'sorting-up': sorting.order === 'asc'
            }"
            @click="setSortingMethod('date_sent')"
          >
            <svg class="table-row-icon">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
            <svg class="table-row-icon table-row-icon-reverse">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'source'">
      <div class="column-filter column-filter--source">
        <div class="cell-flex pointer" @click="setSortingMethod('source')">
          {{ $tr('common.list.source') }}

          <div
            class="table-row-icon_wrapper table-row-icon_wrapper__sort"
            :class="{
              active: sorting.name === 'source',
              'sorting-down': sorting.order === 'desc',
              'sorting-up': sorting.order === 'asc'
            }"
          >
            <svg class="table-row-icon">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
            <svg class="table-row-icon table-row-icon-reverse">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="header.id === 'creator'" :ref="`th-${header.id}`">
      <div class="column-filter">
        {{ $tr('common.list.vacancyCreator') }}

        <div
          v-if="filter_creators && filter_creators.length > 0"
          class="column-filter-icon"
          @click.stop="set_show_filter('vacancy_user_id')"
        >
          <icon-filter :color="filter.vacancy_user_id.length > 0 ? 'green' : 'grey'" />
        </div>

        <vtfilter
          v-if="show_filter === 'vacancy_user_id'"
          :list="filter_creators"
          :selected_list="filter_temp_selected_creators"
          :input_placeholder="$tr('common.list.vacancyCreator')"
          class="th_filter"
          type="list"
          filter_name="creator"
          @input="set_filter_temp_selected_creators"
          @apply="apply_filter('vacancy_user_id')"
          @cancel="cancel_filter"
          @clear="creator_clear"
        />
      </div>
    </template>
    <template v-else-if="header.id === 'tags'">
      <div class="column-filter">
        {{ $tr('common.list.tags') }}

        <div
          v-if="filter_tags && filter_tags.length > 0"
          class="column-filter-icon"
          @click.stop="set_show_filter('tag_id')"
        >
          <icon-filter :color="filter_temp_selected_tags.length > 0 ? 'green' : 'grey'" />
        </div>

        <vtfilter
          v-if="show_filter === 'tag_id'"
          class="th_filter"
          type="list"
          :list="filter_tags"
          :selected_list="filter_temp_selected_tags"
          :input_placeholder="$tr('common.list.tags')"
          filter_name="tag_id"
          @input="set_filter_temp_selected_tags"
          @apply="apply_filter('tag_id')"
          @cancel="cancel_filter"
          @clear="tags_clear"
        />
      </div>
    </template>
    <template v-else-if="header.id.indexOf('attribute_') !== -1">
      <div class="column-filter">
        <div class="cell-flex pointer" @click="setSortingMethod(`response_${header.id}`)">
          {{ header.name }}

          <div
            class="table-row-icon_wrapper table-row-icon_wrapper__sort"
            :class="{
              active: sorting.name === `response_attribute_${header.id}`,
              'sorting-down': sorting.order === 'desc',
              'sorting-up': sorting.order === 'asc'
            }"
          >
            <svg class="table-row-icon">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
            <svg class="table-row-icon table-row-icon-reverse">
              <use xlink:href="/static/icons/table-icons.svg#sort" />
            </svg>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      {{ header.name }}
    </template>
  </div>
</template>

<script>
import { ResponsesHeaderMixin } from './headerMixin';
import appendToBody from '@/directives/appendToBody.js';

export default {
  directives: {
    appendToBody
  },

  mixins: [ResponsesHeaderMixin],
  props: {
    list: Array,
    isItSearch: {
      type: Boolean,
      default: false
    },

    filter_temp_selected_statuses: Array,
    filter_temp_dates: Array,
    filter_temp_dates_created: Array,
    filter_temp_selected_creators: Array,
    filter_temp_selected_tags: Array,
    show_filter: {
      type: String,
      default: 'none'
    },

    filter_loaded: Boolean,
    filter_statuses: Array,
    filter_creators: Array,
    filter_tags: Array,
    headers: Array,
    header: Object
  }
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;

  .search th:hover {
    cursor: default;
  }
}

table th.column-checkbox {
  width: 60px;
  box-sizing: border-box;
}

.column-vacancy {
  width: 8.5%;
}

.column-creator {
  width: 174px;
}

.column-avatar {
  width: 13%;
}

.column-status {
  width: 8.5%;
}

.column-status-refuse {
  width: 8.5%;
}

.column-rating {
  width: 8.5%;
}

.column-source {
  width: 8.5%;
}

.column-date {
  width: 8.5%;
}

.column-comments {
  width: 25%;

  @media (max-width: 1700px) {
    width: 11.5%;
  }

  @media (max-width: 1450px) {
    width: 170px;
  }
}

.column-candidate {
  width: 9%;
}

.column-resume {
  width: 8.5%;
}

.column-filter {
  position: relative;
  display: flex;
  align-items: center;
  &--source {
    min-width: 141px;
  }
}

.column-filter-icon {
  margin-left: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.th_filter {
  position: absolute;
  left: 0;
  top: 45px;
  margin-top: 20px;

  ::v-deep &.daterange {
    margin-top: 10px;
  }
}
</style>
